const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user-lite?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchSchool({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user-lite/master-school`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchFilter({ commit }, { status, roleId, masterSchoolId }) {
    if (status !== '' && typeof status != 'undefined') {
      const status = status;
    } else {
      status = '';
    }
    try {
      const {
        data: { data }
      } = await window.axios.get(
        `/api/user-lite?status=${status}&roleId=${roleId ? roleId : ''}&masterSchoolId=${masterSchoolId ? masterSchoolId : ''}`
      );
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user-lite/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    return window.axios.put(`/api/user-lite/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/user-lite/${payload.userId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
